import React from 'react';
import Header from 'modules/header/wholesaler/main';
import MyAdvertismentDetail from 'modules/myAdvertisment/myAdvertismentDetail';

const MyAdvertismentDetailContainer = () => {
  return (
    <div>
      <Header title={'مدیریت آگهی'} />
      <MyAdvertismentDetail app={'wholesaler'} />
    </div>
  );
};

export default MyAdvertismentDetailContainer;
